import type { ArticleOverviewType, IAPIArticleTeaser } from '@hokify/magazine-interface';
import { computed, ref } from 'vue';
import { useMagazineStore } from '@/stores/magazine';

export function useMagazineBase($pinia?: any) {
	const magazineStore = useMagazineStore($pinia);

	const articleTeasers = computed(() => magazineStore.articleTeasers);

	const articlesPerApiCall = ref(10);

	const setArticlesPerApiCall = (value: number) => {
		articlesPerApiCall.value = value;
	};

	const loadArticlesForCategory = async (params: {
		category: string;
		page?: number;
		limit?: number;
	}) => {
		try {
			return await magazineStore.loadArticlesForCategory(params);
		} catch (error) {
			console.error('Error loading articles for category:', error);
		}
	};

	const loadArticles = async (params: {
		articleOverviewType: ArticleOverviewType;
		includeInterlinking?: boolean;
	}) => {
		try {
			return await magazineStore.loadArticles(params);
		} catch (error) {
			console.error('Error loading articles:', error);
		}
	};

	const hasCoreArticle = (categoryArticles: IAPIArticleTeaser[]): boolean =>
		!!categoryArticles?.[0]?.isCoreArticle;

	const upcomingEventsAscending = (): IAPIArticleTeaser[] =>
		[...articleTeasers.value.upcomingevents].sort(
			(x, y) => new Date(x.date).getTime() - new Date(y.date).getTime()
		);

	const partnersAscending = (): IAPIArticleTeaser[] =>
		[...articleTeasers.value.partners].sort((x, y) =>
			x.title.toUpperCase().localeCompare(y.title.toUpperCase())
		);

	return {
		articleTeasers,
		articlesPerApiCall,
		setArticlesPerApiCall,
		loadArticlesForCategory,
		loadArticles,
		hasCoreArticle,
		upcomingEventsAscending,
		partnersAscending
	};
}
